import React, { useState } from "react";
import { Typography, MenuItem, Select } from "@mui/material";
import { MonthYearPickerStyled } from "./month-year-picker.styles"; // New stylesheet
import { datePickerProps } from "../date-picker/date-picker.type";
import InfoIcon from "../../info-icon/info-icon";
import PropTypes from "prop-types";
import dayjs from "dayjs";

const MonthYearPickerField = (props) => {
  const {
    value,
    onChange,
    name,
    label,
    placeholder = "Select Month-Year",
    size = "small",
    isRequired,
    disabled,
    description,
    minYear = 2023,
    maxYear = dayjs().year(),
  } = props;

  const [selectedMonth, setSelectedMonth] = useState(value ? dayjs(value).month() : null);
  const [selectedYear, setSelectedYear] = useState(value ? dayjs(value).year() : null);

  const handleMonthChange = (event) => {
    const month = event.target.value;
    setSelectedMonth(month);
    if (selectedYear !== null) {
      onChange(dayjs().year(selectedYear).month(month).startOf("month"));
    }
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (selectedMonth !== null) {
      onChange(dayjs().year(year).month(selectedMonth).startOf("month"));
    }
  };

  const renderMonthOptions = () => {
    return dayjs.months().map((month, index) => (
      <MenuItem key={index} value={index}>
        {month}
      </MenuItem>
    ));
  };

  const renderYearOptions = () => {
    const years = [];
    for (let year = minYear; year <= maxYear; year++) {
      years.push(
        <MenuItem key={year} value={year}>
          {year}
        </MenuItem>
      );
    }
    return years;
  };

  return (
    <MonthYearPickerStyled>
      {label && (
        <Typography className="label">
          {label}
          {isRequired && "*"}
          {description && <InfoIcon message={description} />}
        </Typography>
      )}

      <div className="picker-wrapper">
        <div className="custom-select" role="button">
          <Select
            value={selectedMonth !== null ? selectedMonth : ""}
            onChange={handleMonthChange}
            displayEmpty
            disabled={disabled}
            className="picker-select"
            variant="standard"
            MenuProps={{ disableScrollLock: true }}
          >
            <MenuItem value="" disabled>
              {placeholder.split("-")[0]} {/* Placeholder for month */}
            </MenuItem>
            {renderMonthOptions()}
          </Select>
        </div>

        <div className="divider" />

        <div className="custom-select" role="button">
          <Select
            value={selectedYear !== null ? selectedYear : ""}
            onChange={handleYearChange}
            displayEmpty
            disabled={disabled}
            className="picker-select"
            variant="standard"
            MenuProps={{ disableScrollLock: true }}
          >
            <MenuItem value="" disabled>
              {placeholder.split("-")[1]} {/* Placeholder for year */}
            </MenuItem>
            {renderYearOptions()}
          </Select>
        </div>
      </div>
    </MonthYearPickerStyled>
  );
};

MonthYearPickerField.propTypes = {
  ...datePickerProps,
  minYear: PropTypes.number,
  maxYear: PropTypes.number,
};

export default React.memo(MonthYearPickerField);
